"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextFilter = exports.RangeFilter = exports.ListFilter = exports.ItemFilter = exports.CounterFilter = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _Slider = _interopRequireDefault(require("../Slider/Slider"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Counter = _interopRequireDefault(require("../Counter/Counter"));

var _FilterInput = _interopRequireDefault(require("../Input/FilterInput/FilterInput"));

var _LabelInput = _interopRequireDefault(require("../Input/LabelInput/LabelInput"));

var _Checkbox = _interopRequireDefault(require("../Input/CheckBox/Checkbox"));

var _RadioButton = _interopRequireDefault(require("../RadioButton/RadioButton"));

var _classNames2 = _interopRequireDefault(require("../../util/classNames"));

var _formatters = require("../../util/formatters");

var _helpers = require("../../util/helpers");

require("./FilterPopover.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var RangeInput = function RangeInput(_ref) {
  var formatFn = _ref.formatFn,
      value = _ref.value,
      onChange = _ref.onChange,
      onStep = _ref.onStep;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      editing = _useState2[0],
      setEditing = _useState2[1];

  var _useState3 = (0, _react.useState)(function () {
    return formatFn(value);
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      internalVal = _useState4[0],
      setInternalVal = _useState4[1];

  (0, _react.useEffect)(function () {
    setInternalVal(formatFn(value));
  }, [value, formatFn]);
  var changePending = (0, _react.useRef)(false);

  var handleChange = function handleChange(e) {
    if (!isNaN(e.target.value.replaceAll(':', ''))) {
      setInternalVal(e.target.value);
      changePending.current = true;
    }
  };

  var blur = function blur() {
    setEditing(false);

    if (changePending.current) {
      onChange(internalVal);
      changePending.current = false;
    }
  };

  var inputRef = (0, _react.useRef)(null);

  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'ArrowUp') {
      //Arrow Up
      onStep(value + 1);
      e.preventDefault();
    } else if (e.key === 'ArrowDown') {
      //Arrow Down
      onStep(value - 1);
      e.preventDefault();
    } else if (e.key === 'Enter') {
      inputRef.current.blur();
    }
  };

  return /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputRef,
    type: "text",
    className: "sb-rf-input",
    value: editing ? internalVal : formatFn(value),
    onChange: handleChange,
    onKeyDown: onKeyDown,
    onFocus: function onFocus() {
      return setEditing(true);
    },
    onBlur: blur
  });
};

var RangeFilter = function RangeFilter(_ref2) {
  var type = _ref2.type,
      value = _ref2.value,
      onChange = _ref2.onChange,
      min = _ref2.min,
      max = _ref2.max,
      onSave = _ref2.onSave,
      saveLabel = _ref2.saveLabel,
      resetLabel = _ref2.resetLabel;

  var _value = _slicedToArray(value, 2),
      low = _value[0],
      high = _value[1];

  var lowLimit = low || min;
  var highLimit = high || max;
  var formatVal = (0, _react.useCallback)(function (val) {
    if (type === 'time') {
      return (0, _formatters.formatTime)(val);
    } else {
      return val;
    }
  }, [type]);

  var changeLowValue = function changeLowValue(val) {
    return onChange([Math.min(Math.max(val, min), highLimit - 1), highLimit]);
  };

  var changeHighValue = function changeHighValue(val) {
    return onChange([lowLimit, Math.max(Math.min(val, max), lowLimit + 1)]);
  };

  var handleChange = function handleChange(val, fn, defaultVal) {
    if (val) {
      if (type === 'time') {
        if ((0, _helpers.isValidTime)(val)) {
          fn((0, _helpers.getTime)(val));
        }
      } else {
        fn(parseInt(val, 10));
      }
    } else {
      fn(defaultVal);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-filter-body sb-range-filter"
  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(RangeInput, {
    formatFn: formatVal,
    value: lowLimit,
    onChange: function onChange(v) {
      return handleChange(v, changeLowValue, min);
    },
    onStep: changeLowValue
  }), /*#__PURE__*/_react["default"].createElement("span", null, "-"), /*#__PURE__*/_react["default"].createElement(RangeInput, {
    formatFn: formatVal,
    value: highLimit,
    onChange: function onChange(v) {
      return handleChange(v, changeHighValue, max);
    },
    onStep: changeHighValue
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-filter-main"
  }, /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    value: [lowLimit, highLimit],
    onChange: onChange,
    min: min,
    max: max
  })), /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return onChange(undefined);
    }
  }, resetLabel), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onSave
  }, saveLabel)));
};

exports.RangeFilter = RangeFilter;
RangeFilter.propTypes = {
  type: _propTypes["default"].oneOf(['time', 'integer']),
  value: _propTypes["default"].arrayOf(_propTypes["default"].number),
  onChange: _propTypes["default"].func.isRequired,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  onSave: _propTypes["default"].func,
  saveLabel: _propTypes["default"].string,
  resetLabel: _propTypes["default"].string
};
RangeFilter.defaultProps = {
  type: 'time',
  value: []
};

var label = function label(v) {
  return _typeof(v) === 'object' ? v.label : '' + v;
};

var val = function val(v) {
  return _typeof(v) === 'object' ? v.value : v;
};

var hasMoreThan = function hasMoreThan(arr, val, limit) {
  var count = 0;

  for (var i = 0; i < arr.length; i++) {
    if (count > limit) return true;
    if (label(arr[i]).toLowerCase().includes(val.toLowerCase())) count++;
  }

  return false;
};

var ListFilter = function ListFilter(_ref3) {
  var id = _ref3.id,
      placeholder = _ref3.placeholder,
      list = _ref3.list,
      values = _ref3.values,
      value = _ref3.value,
      type = _ref3.type,
      search = _ref3.search,
      smart = _ref3.smart,
      selectAll = _ref3.selectAll,
      noReset = _ref3.noReset,
      noButtons = _ref3.noButtons,
      _onChange = _ref3.onChange,
      onSave = _ref3.onSave,
      labels = _ref3.labels;
  var dynamicSearch = smart && list && list.length > 50;
  var hasSelectAll = selectAll && type === 'checks';
  var hasHeader = search || smart || hasSelectAll;

  var _useState5 = (0, _react.useState)(dynamicSearch ? [] : list),
      _useState6 = _slicedToArray(_useState5, 2),
      filteredList = _useState6[0],
      setFilteredList = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      searchValue = _useState8[0],
      setSearchValue = _useState8[1];

  (0, _react.useEffect)(function () {
    if (smart && list && list.length > 50) {
      if (searchValue.length > 2) {
        if (hasMoreThan(list, searchValue, 50)) setFilteredList(list.filter(function (v) {
          return label(v).toLowerCase() === searchValue.toLowerCase();
        }));else setFilteredList(list.filter(function (v) {
          return label(v).toLowerCase().includes(searchValue.toLowerCase());
        }));
      } else {
        if (hasMoreThan(list, searchValue, 10)) setFilteredList(list.filter(function (v) {
          return label(v).toLowerCase() === searchValue.toLowerCase();
        }));else setFilteredList(list.filter(function (v) {
          return label(v).toLowerCase().includes(searchValue.toLowerCase());
        }));
      }
    }
  }, [smart, searchValue, list]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'sb-filter-body sb-list-filter' + (search || smart ? ' sb-search-filter' : '') + (noButtons ? ' no-buttons' : ''),
    id: id
  }, hasHeader && /*#__PURE__*/_react["default"].createElement("header", null, dynamicSearch ? /*#__PURE__*/_react["default"].createElement(_FilterInput["default"], {
    placeholder: placeholder,
    customFilter: true,
    onChange: setSearchValue
  }) : (smart || search) && /*#__PURE__*/_react["default"].createElement(_FilterInput["default"], {
    placeholder: placeholder,
    data: list,
    filterBy: "label",
    onChange: setFilteredList,
    ignoreCase: true
  }), hasSelectAll && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "tertiary",
    onClick: function onClick() {
      return _onChange(list.map(function (v) {
        return val(v);
      }));
    }
  }, labels.selectAll)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-filter-main"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sbf-list-filter-scroll"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sbf-list-filter-list"
  }, dynamicSearch && searchValue === '' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, values.map(function (v, i) {
    return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      key: val(v),
      id: id + '-chk-' + i,
      caption: label(v),
      checked: true,
      onChange: function onChange() {
        return _onChange(values.filter(function (e) {
          return e !== val(v);
        }));
      },
      tooltip: label(v).length > 23 && label(v)
    });
  })) : filteredList.map(function (v, i) {
    return type === 'checks' ? /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      key: i,
      id: id + '-chk-' + i,
      caption: label(v),
      checked: values.includes(val(v)),
      onChange: function onChange(checked) {
        return _onChange(checked ? [].concat(_toConsumableArray(values), [val(v)]) : values.filter(function (e) {
          return e !== val(v);
        }));
      },
      tooltip: label(v).length > 23 && label(v)
    }) : /*#__PURE__*/_react["default"].createElement(_RadioButton["default"], {
      key: i,
      id: id + '-rdb-' + i,
      name: id,
      label: label(v),
      value: val(v),
      checked: value === val(v),
      onChange: _onChange,
      tooltip: label(v).length > 23 && label(v)
    });
  })))), !noButtons && /*#__PURE__*/_react["default"].createElement("footer", null, !noReset && labels.reset != null && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return _onChange(type === 'checks' ? [] : null);
    }
  }, labels.reset), labels.save != null && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onSave
  }, labels.save)));
};

exports.ListFilter = ListFilter;
ListFilter.propTypes = {
  id: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  list: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].any
  })])),
  values: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  search: _propTypes["default"].bool,
  smart: _propTypes["default"].bool,
  selectAll: _propTypes["default"].bool,
  noReset: _propTypes["default"].bool,
  noButtons: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(['checks', 'radios']),
  onChange: _propTypes["default"].func.isRequired,
  onSave: _propTypes["default"].func,
  labels: _propTypes["default"].shape({
    reset: _propTypes["default"].string,
    save: _propTypes["default"].string,
    selectAll: _propTypes["default"].string
  })
};
ListFilter.defaultProps = {
  list: [],
  values: [],
  value: null,
  search: false,
  smart: false,
  selectAll: false,
  noReset: false,
  noButtons: false,
  type: 'checks',
  labels: {}
};

var TextFilter = function TextFilter(_ref4) {
  var placeholder = _ref4.placeholder,
      value = _ref4.value,
      onChange = _ref4.onChange,
      onSave = _ref4.onSave,
      saveLabel = _ref4.saveLabel,
      minValLength = _ref4.minValLength,
      numeric = _ref4.numeric;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-filter-body sb-text-filter"
  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_LabelInput["default"], {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    label: placeholder,
    onlyNumbers: numeric
  })), /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onSave,
    disabled: minValLength != null && value.length < minValLength
  }, saveLabel)));
};

exports.TextFilter = TextFilter;
TextFilter.propTypes = {
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  onSave: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  saveLabel: _propTypes["default"].string
};
TextFilter.defaultProps = {
  value: ''
};

var ItemFilter = function ItemFilter(_ref5) {
  var placeholder = _ref5.placeholder,
      values = _ref5.values,
      onChange = _ref5.onChange,
      onSave = _ref5.onSave,
      resetLabel = _ref5.resetLabel,
      saveLabel = _ref5.saveLabel,
      noReset = _ref5.noReset,
      minValLength = _ref5.minValLength,
      numeric = _ref5.numeric;

  var _useState9 = (0, _react.useState)(''),
      _useState10 = _slicedToArray(_useState9, 2),
      value = _useState10[0],
      setValue = _useState10[1];

  var addValue = function addValue() {
    onChange([].concat(_toConsumableArray(values), [value]));
    setValue('');
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-filter-body sb-item-filter"
  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement(_LabelInput["default"], {
    value: value,
    onChange: setValue,
    placeholder: placeholder,
    label: placeholder,
    onlyNumbers: numeric
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: addValue,
    disabled: minValLength != null ? value.length < minValLength : value.length === 0
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon larger plus"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-filter-main"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sbf-list-filter-scroll"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sbf-list-filter-list"
  }, values.map(function (v) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "sbif-item"
    }, v, /*#__PURE__*/_react["default"].createElement("i", {
      className: "gcl-icon clickable close-circle",
      onClick: function onClick() {
        return onChange(values.filter(function (l) {
          return l !== v;
        }));
      }
    }));
  })))), /*#__PURE__*/_react["default"].createElement("footer", null, !noReset && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return onChange([]);
    }
  }, resetLabel), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onSave
  }, saveLabel)));
};

exports.ItemFilter = ItemFilter;
ItemFilter.propTypes = {
  values: _propTypes["default"].array,
  onChange: _propTypes["default"].func.isRequired,
  onSave: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  saveLabel: _propTypes["default"].string,
  resetLabel: _propTypes["default"].string,
  noReset: _propTypes["default"].bool,
  minValLength: _propTypes["default"].number,
  numeric: _propTypes["default"].bool
};
ItemFilter.defaultProps = {
  values: []
};

var CounterFilter = function CounterFilter(_ref6) {
  var value = _ref6.value,
      onChange = _ref6.onChange,
      step = _ref6.step,
      min = _ref6.min,
      max = _ref6.max,
      onSave = _ref6.onSave,
      noButtons = _ref6.noButtons,
      message = _ref6.message,
      saveLabel = _ref6.saveLabel,
      resetLabel = _ref6.resetLabel;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-filter-body sb-counter-filter"
  }, /*#__PURE__*/_react["default"].createElement("header", {
    lang: "en"
  }, message), /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-filter-main"
  }, /*#__PURE__*/_react["default"].createElement(_Counter["default"], {
    start: value,
    min: min,
    max: max,
    step: step,
    onChange: onChange
  })), !noButtons && /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      return onChange(undefined);
    }
  }, resetLabel), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onSave
  }, saveLabel)));
};

exports.CounterFilter = CounterFilter;
CounterFilter.propTypes = {
  value: _propTypes["default"].number,
  onChange: _propTypes["default"].func.isRequired,
  step: _propTypes["default"].number,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  onSave: _propTypes["default"].func,
  noButtons: _propTypes["default"].bool,
  message: _propTypes["default"].string,
  saveLabel: _propTypes["default"].string,
  resetLabel: _propTypes["default"].string
};

var FilterPopover = function FilterPopover(_ref7) {
  var _classNames;

  var id = _ref7.id,
      placeholder = _ref7.placeholder,
      valueLabel = _ref7.valueLabel,
      labelPlural = _ref7.labelPlural,
      value = _ref7.value,
      className = _ref7.className,
      onSave = _ref7.onSave,
      disabled = _ref7.disabled,
      large = _ref7.large,
      position = _ref7.position,
      customToggle = _ref7.customToggle,
      tooltip = _ref7.tooltip,
      children = _ref7.children;

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isOpen = _useState12[0],
      setOpen = _useState12[1];

  var toggle = function toggle() {
    return setOpen(!isOpen);
  };

  var saveHandler = function saveHandler() {
    setOpen(false);
    onSave && onSave();
  };

  var label = function label() {
    var composed = function composed(val) {
      return val > 0 ? "".concat(val, " ").concat(val === 1 ? valueLabel : labelPlural || valueLabel) : valueLabel;
    };

    if (!value) return placeholder;
    if (Array.isArray(value)) return value.length > 0 ? "".concat(value[0], " - ").concat(value[value.length - 1]) : placeholder;
    if (isNaN(value) || valueLabel == null) return value;else return composed(value);
  };

  var classes = (0, _classNames2["default"])((_classNames = {}, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "disabled", disabled), _defineProperty(_classNames, "empty", !value || Array.isArray(value) && value.length === 0), _defineProperty(_classNames, "open", isOpen), _classNames));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, customToggle ? /*#__PURE__*/_react["default"].cloneElement(customToggle, {
    id: id,
    disabled: disabled,
    className: customToggle.props.className + ' ' + (0, _classNames2["default"])({
      'sb-filter-custom-toggle': true,
      empty: !value || Array.isArray(value) && value.length === 0,
      open: isOpen
    })
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: 'sb-filter-toggle ' + classes
  }, label()), tooltip && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: id
  }, tooltip), /*#__PURE__*/_react["default"].createElement(_reactstrap.Popover, {
    className: 'sb-filter-popover' + (large ? ' large' : ''),
    placement: 'bottom-' + position,
    target: id,
    isOpen: isOpen,
    toggle: toggle,
    disabled: disabled,
    trigger: "legacy",
    hideArrow: true,
    fade: false
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, null, children && /*#__PURE__*/_react["default"].cloneElement(children, {
    onSave: saveHandler
  }))));
};

FilterPopover.propTypes = {
  id: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  valueLabel: _propTypes["default"].string,
  labelPlural: _propTypes["default"].string,
  value: _propTypes["default"].any,
  onSave: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  large: _propTypes["default"].bool,
  customToggle: _propTypes["default"].node,
  tooltip: _propTypes["default"].string,
  className: _propTypes["default"].string,
  position: _propTypes["default"].oneOf(['start', 'end'])
};
FilterPopover.defaultProps = {
  className: '',
  large: false,
  position: 'start'
};
var _default = FilterPopover;
exports["default"] = _default;